import React from "react"
import { Flex } from "@chakra-ui/react"
import { isConstructorType } from "../../../utils"
import DesktopItem from "./DesktopItem"
import DesktopDropdown from "./DesktopDropdown"

export default function Desktop({ menu }) {
  const baseStyle = {
    _expanded: { color: "white" },
    textTransform: "uppercase",
    letterSpacing: "widest",
    textDecoration: "none",
    fontWeight: "medium",
    _notLast: { mr: 6 },
    color: "gray.200",
    fontSize: "xs",
    bg: "none",
  }

  const primaryStyle = {
    layerStyle: "foreground",
    _hover: { bg: "white" },
    fontWeight: "bold",
    color: "gray.d100",
    bg: "primary.200",
    px: 3,
    py: 2,
  }

  return (
    <Flex as="nav" display={{ base: "none", lg: "flex" }} alignItems="center">
      {menu.map(({ isPrimary, label, url }, index) => {
        const style = isPrimary ? { ...baseStyle, ...primaryStyle } : baseStyle
        const props = {
          style,
          label,
          url,
        }

        return isConstructorType("string", url) ? (
          <DesktopItem key={index} {...props} />
        ) : (
          <DesktopDropdown key={index} {...props} />
        )
      })}
    </Flex>
  )
}
